import mitt from 'mitt';

class EventBus {
  static getEventBus = () => {
    if (!window['caiEventBus']) {
      const emitter = mitt();
      window['caiEventBus'] = emitter;
    }
    return window['caiEventBus'];
  };

  private static eventBus = this.getEventBus();

  static publish(event, value) {
    try {
      if (this.eventBus && typeof this.eventBus.emit === 'function') {
        this.eventBus.emit(event, value);
      }
    } catch (e) {
      console.error('Error publishing to event bus.', e);
    }
  }

  static subscribe(event: string = '', handler: Function) {
    try {
      if (this.eventBus && typeof this.eventBus.on === 'function') {
        this.eventBus.on(event, handler);
      }
    } catch (e) {
      console.error(`Error subscribing to event ${event}`, e);
    }
  }

  // mittjs also allows you to unsubscribe from events with specific handler functions
  // this one unsubscribes from all events with event name
  static unsubscribeAll(event: string = '') {
    try {
      if (this.eventBus && typeof this.eventBus.off === 'function') {
        this.eventBus.off(event);
      }
    } catch (e) {
      console.error(`Error unsubscribing all from event ${event}`, e);
    }
  }

  static unsubscribe(event: string = '', handler: Function) {
    try {
      if (this.eventBus && typeof this.eventBus.off === 'function') {
        this.eventBus.off(event, handler);
      }
    } catch (e) {
      console.error(`Error unsubscribing from event ${event}`, e);
    }
  }
}

export default EventBus;
